import type { ProjectSortKey } from '@noma-eco/platform/schema';

/**
 * The curated set of projects-list sort tokens, in dropdown order. The type
 * comes from the generated OpenAPI contract (`ProjectSortKey`); this const is
 * the runtime list the URL validator and the preference-mirror guard need.
 * `satisfies` pins every entry to a real contract token, so a typo or a
 * backend rename fails to compile here.
 */
export const PROJECT_SORT_KEYS = [
  'visited_desc',
  'updated_desc',
  'created_desc',
  'created_asc',
] as const satisfies readonly ProjectSortKey[];

export const DEFAULT_PROJECT_SORT: ProjectSortKey = 'visited_desc';

export function isProjectSortKey(value: unknown): value is ProjectSortKey {
  return (PROJECT_SORT_KEYS as readonly string[]).includes(value as string);
}
